<script setup lang="ts">
import { AdjustmentsHorizontalIcon, ChevronDownIcon, ChevronUpIcon } from '@heroicons/vue/24/outline'
import { ref, type Component } from 'vue'

const props = withDefaults(defineProps<{
  title: string
  icon?: Component
  defaultExpanded?: boolean
}>(), {
  defaultExpanded: true,
})

const isExpanded = ref(props.defaultExpanded)

function toggleExpanded() {
  isExpanded.value = !isExpanded.value
}
</script>

<template>
  <div class="min-w-0 w-full max-w-full border-b border-stroke bg-white shadow-md">
    <button
      type="button"
      class="flex w-full items-center justify-between gap-3 px-4 py-4 text-left"
      @click="toggleExpanded">
      <span class="flex items-center gap-2 font-satoshi text-sm font-semibold text-black">
        <component
          :is="icon || AdjustmentsHorizontalIcon"
          class="h-5 w-5 shrink-0 text-blue"
          aria-hidden="true" />
        {{ title }}
      </span>
      <ChevronUpIcon v-if="isExpanded" class="h-5 w-5 shrink-0 text-gray-500" aria-hidden="true" />
      <ChevronDownIcon v-else class="h-5 w-5 shrink-0 text-gray-500" aria-hidden="true" />
    </button>

    <div v-show="isExpanded" class="min-w-0 w-full border-t border-stroke">
      <slot />
    </div>
  </div>
</template>
